import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    'comment', 
    'path', 
    'commentList', 
    'commentForm', 
    'commentFormButtons',
    'showCommentsLink', 
    'addCommentLink', 
    'cancelButton'
  ];
  
  static values = {
    autoExpand: Boolean
  }

  connect() {
    // Initially hide the comment list and form
    this.hideCommentList();
    this.hideCommentForm();
    
    // Auto-expand comments if coming from a comment link
    if (this.autoExpandValue === true) {
      this.showCommentList();
      // Scroll to comments section smoothly
      setTimeout(() => {
        this.element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  }

  toggleCommentList(event) {
    event.preventDefault();
    
    if (this.commentListTarget.classList.contains('d-none')) {
      this.showCommentList();
    } else {
      this.hideCommentList();
    }
  }

  showCommentList() {
    this.commentListTarget.classList.remove('d-none');
    const commentCount = this.showCommentsLinkTarget.dataset.commentCount;
    this.showCommentsLinkTarget.textContent = `Hide ${commentCount} comments`;
  }

  hideCommentList() {
    this.commentListTarget.classList.add('d-none');
    const commentCount = this.showCommentsLinkTarget.dataset.commentCount;
    this.showCommentsLinkTarget.textContent = `Show ${commentCount} comments`;
  }

  showCommentForm(event) {
    event.preventDefault();
    this.commentFormTarget.classList.remove('d-none');
    this.commentFormButtonsTarget.classList.remove('d-none');
    this.addCommentLinkTarget.classList.add('d-none');
  }

  hideCommentForm() {
    this.commentFormTarget.classList.add('d-none');
    this.commentFormButtonsTarget.classList.add('d-none');
    this.addCommentLinkTarget.classList.remove('d-none');
  }

  submit(event) {
    event.preventDefault();
    
    const content = this.commentTarget.value.trim();
    const path = this.pathTarget.value;
    
    if (!content) return;
    
    // Create fetch request
    fetch(path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({
        comment: { content }
      })
    })
    .then(response => {
      if (response.ok) {
        // Clear the comment field
        this.commentTarget.value = '';
        // Hide the form and show the add comment link
        this.hideCommentForm();
      } else {
        console.error('Error submitting comment');
      }
    })
    .catch(error => console.error('Error:', error));
  }
}
